export const users = {
  items: 1,
  data: [{
    name: 'Kenny',
    surname: 'Yeo',
    imageUrl: '/kenny.jpg',
    status: 'building a blog tool'
  }]
};




// WEBPACK FOOTER //
// ./src/data/tmp/users.js